// @flow

export const toTitleCase = (str?: string | any): any | void | string => {
  if (typeof str !== "string") return str

  const splitStr = str.toLowerCase().split(" ")

  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
  }

  return splitStr.join(" ")
}

export function upperCaseSnakeCase(string: string): string {
  return string.replace(/ /g, "_").toUpperCase()
}

export const removeWhitespaces = (string: string): string => {
  return string.replace(/ /g, "")
}

export const sortString = (a: Object, b: Object): number => {
  if (a.name < b.name) return -1
  if (a.name > b.name) return 1
  return 0
}
export const loremIpsum =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
